import { RouteVariables } from 'types/route-variables'

export const ROUTES = {
  PRODUCERS: {
    nl: 'onze-producenten',
    fr: 'nos-producteurs'
  },
  PRODUCER_INFO: {
    nl: `onze-producenten/${RouteVariables.SLUG}`,
    fr: `nos-producteurs/${RouteVariables.SLUG}`
  },
  PERSONALIZED_OFFER: {
    nl: 'onze-producenten/jouw-persoonlijk-aanbod',
    fr: 'nos-producteurs/votre-offre-personnelle'
  },
  REGISTRATION: {
    nl: `onze-producenten/${RouteVariables.SLUG}/bestel`,
    fr: `nos-producteurs/${RouteVariables.SLUG}/ordre`
  },
  ABOUT: {
    nl: 'over-ons',
    fr: 'qui-sommes-nous'
  },
  FAQ: {
    nl: 'veelgestelde-vragen',
    fr: 'questions-frequentes'
  },
  TERMS_AND_CONDITIONS: {
    nl: 'algemene-voorwaarden',
    fr: 'termes-et-conditions'
  },
  CAREERS: {
    nl: 'vacatures',
    fr: 'jobs'
  },
  PRICELISTS: {
    nl: 'prijslijsten',
    fr: 'listes-des-prix'
  },
  PRIVACY: {
    nl: 'disclaimer-privacy-policy',
    fr: 'mentions-legales-politique-de-confidentialite'
  },
  SETTLEMENT: {
    nl: 'jaarafrekening',
    fr: 'regularisation'
  },
  REFERRAL: {
    nl: 'overtuig-een-vriend',
    fr: 'convaincre-un-ami'
  },
  MINI_GENERATORS: {
    nl: 'mini-opwekkers',
    fr: 'mini-producteurs'
  },
  PROJECTS: {
    nl: 'projecten',
    fr: 'projets'
  },
  PROJECT_CAMPING_BELGICA: {
    nl: 'projecten/camping-belgica',
    fr: 'projets/camping-belgica'
  },
  PROJECT_EVA_DE_ROO: {
    nl: 'projecten/eva-de-roo',
    fr: 'projets/eva-de-roo'
  },
  PROJECT_BRUSSELS_BEER_PROJECT: {
    nl: 'projecten/brussels-beer-project',
    fr: 'projets/brussels-beer-project'
  },
  PROJECT_ICELAND: {
    nl: 'projecten/stop-sjoemelstroom-ijsland',
    fr: 'projets/energievertdegris-islande'
  },
  PROJECT_FESTIVALS: {
    nl: 'projecten/de-wei-dieselvrij',
    fr: 'projets/les-festivals-sans-diesel'
  },
  PRICING: {
    nl: 'prijzen',
    fr: 'prix'
  },
  FAQ_PRICE_INCREASE: {
    nl: 'veelgestelde-vragen/uitzonderlijke-energieprijzen',
    fr: 'questions-frequentes/prix-de-lenergie-exceptionnels'
  },
  HONEST_ENERGY: {
    nl: 'eerlijke-energie'
    // no fr
  },
  BECOME_GENERATOR: {
    nl: 'opwekker-worden',
    fr: 'devenir-produceur'
  },
  ENCYCLOPEDIA: {
    nl: 'encyclopedie',
    fr: 'encyclopedie'
  },
  ENCYCLOPEDIA_CATEGORY: {
    nl: `encyclopedie/${RouteVariables.CATEGORY}`
    // fr: `encyclopedie/${RouteVariables.CATEGORY}`
  },
  ENCYCLOPEDIA_SUB_CATEGORY: {
    nl: `encyclopedie/${RouteVariables.CATEGORY}/${RouteVariables.SUB_CATEGORY}`
    // fr: `encyclopedie/${RouteVariables.CATEGORY}/${RouteVariables.SUB_CATEGORY}`
  },
  ENCYCLOPEDIA_ARTICLE: {
    nl: `encyclopedie/${RouteVariables.CATEGORY}/${RouteVariables.SUB_CATEGORY}/${RouteVariables.ARTICLE}`
    // fr: `encyclopedie/${RouteVariables.CATEGORY}/${RouteVariables.SUB_CATEGORY}/${RouteVariables.ARTICLE}`
  }
}

export const STATIC_ROUTES = [
  {
    nl: 'onze-producenten',
    fr: 'nos-producteurs'
  },
  {
    nl: 'over-ons',
    fr: 'qui-sommes-nous'
  },
  {
    nl: 'veelgestelde-vragen',
    fr: 'questions-frequentes'
  },
  {
    nl: 'algemene-voorwaarden',
    fr: 'termes-et-conditions'
  },
  {
    nl: 'vacatures',
    fr: 'jobs'
  },
  {
    nl: 'prijslijsten',
    fr: 'listes-des-prix'
  },
  {
    nl: 'disclaimer-privacy-policy',
    fr: 'mentions-legales-politique-de-confidentialite'
  },
  {
    nl: 'jaarafrekening',
    fr: 'regularisation'
  },
  {
    nl: 'overtuig-een-vriend',
    fr: 'convaincre-un-ami'
  },
  {
    nl: 'mini-opwekkers',
    fr: 'mini-producteurs'
  },
  {
    nl: 'projecten',
    fr: 'projets'
  },
  {
    nl: 'projecten/camping-belgica',
    fr: 'projets/camping-belgica'
  },
  {
    nl: 'projecten/eva-de-roo',
    fr: 'projets/eva-de-roo'
  },
  {
    nl: 'projecten/brussels-beer-project',
    fr: 'projets/brussels-beer-project'
  },
  {
    nl: 'projecten/stop-sjoemelstroom-ijsland',
    fr: 'projets/energievertdegris-islande'
  },
  {
    nl: 'projecten/de-wei-dieselvrij',
    fr: 'projets/les-festivals-sans-diesel'
  },
  {
    nl: 'win/festivals'
  },
  {
    nl: 'prijzen',
    fr: 'prix'
  },
  {
    nl: 'gele-stroom'
  },
  {
    nl: 'jaarafrekening',
    fr: 'regularisation'
  },
  {
    nl: 'veelgestelde-vragen/uitzonderlijke-energieprijzen',
    fr: 'questions-frequentes/prix-de-lenergie-exceptionnels'
  },
  {
    nl: 'eerlijke-energie'
  },
  {
    nl: 'win'
  },
  {
    nl: 'interviews/gruun'
  },
  {
    nl: 'interviews/kwiek'
  },
  {
    nl: 'interviews/house-raccoon'
  },
  {
    nl: 'interviews/swapfiets'
  }
]
